<template>
  <div class="enterprise-detail">
    <p class="title">企业客户还车</p>
    <div class="steps-wrapper">
      <ReturnCarStep :fixedStepIndex="originStep" :currentStepIndex="currentStep" :steps="stepList" @change="handelStepClick" />
    </div>
    <div>
      <keep-alive>
        <component :is="currentComponent" :orderId="queries.orderId" />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import ReturnCarStep from '../components/returnCarStep'

import ReturnCarBeginDetail from '@/pages/cars/returnCar/detail/components/returnCarBegin'
import CheckoutCarDetail from '@/pages/cars/returnCar/detail/components/checkoutCar'
import CheckoutOrderDetail from '@/pages/cars/returnCar/detail/components/checkoutOrder'
import CheckoutExpenseDetail from '@/pages/cars/returnCar/detail/components/checkoutExpense'

import { getOrderDetail, getReturnCarOrderDetail } from '@/api/domain/returnLease'
import { ORDER_STATES, ORDER_TYPES, ENTERPRISE_RETURN_CAR_STEPS, RETURN_CAR_ORDER_STATES } from '@/pages/cars/returnCar/config'

export default {
  provide() {
    return {
      orderType: ORDER_TYPES.enterprise.value,
      orderData: this.orderData,
      returnCarOrderData: this.returnCarOrderData,
    }
  },
  data() {
    return {
      originStep: -1,
      currentStep: -1,
      stepList: ENTERPRISE_RETURN_CAR_STEPS,
      orderData: {},
      returnCarOrderData: {},
      queries: JSON.parse(decodeURIComponent(this.$route.query.query || '{}')),
    }
  },
  computed: {
    currentComponent() {
      if (this.currentStep === 0) {
        return 'ReturnCarBeginDetail'
      } else if (this.currentStep === 1) {
        return 'CheckoutCarDetail'
      } else if (this.currentStep === 2) {
        return 'CheckoutOrderDetail'
      }
      return ''
    },
  },
  methods: {
    async init() {
      const { id, orderId } = this.queries

      if (orderId) {
        await this.getOrderDetail(orderId)
      }

      if (id || orderId) {
        await this.getReturnCarOrderDetail({
          id,
          orderId,
        })
      }

      this.locateStepByOrderData()
    },
    locateStepByOrderData() {
      const { state } = this.orderData
      const { state: returnCarState } = this.returnCarOrderData
      let step = 0

      // 先看退车单状态是否“已关闭”和“已完成”，然后再看订单状态
      if (returnCarState === RETURN_CAR_ORDER_STATES.returnCarClosed.value) {
        step = 0
      } else if (returnCarState === RETURN_CAR_ORDER_STATES.returnCarCompleted.value) {
        step = 3
      } else if (state === ORDER_STATES.returnCarCheckoutWaiting.value) {
        step = 0
      } else if (state === ORDER_STATES.checkoutOrderWaiting.value) {
        step = 1
      }

      this.originStep = step
      this.currentStep = 0
    },
    handelStepClick(stepIndex) {
      if (stepIndex <= this.originStep) {
        this.currentStep = stepIndex
      }
    },
    async getOrderDetail() {
      const { orderId } = this.queries

      if (orderId) {
        let res

        try {
          res = await getOrderDetail({
            orderId: parseInt(orderId),
          })
        } catch (err) {
          console.error(err)
        }

        if (!res) return

        const { code, data } = res
        if (code === 1) {
          Object.keys(data).forEach((key) => {
            this.orderData[key] = data[key]
          })
        }
      }
    },
    async getReturnCarOrderDetail({ id, orderId }) {
      let res

      try {
        res = await getReturnCarOrderDetail({
          id,
          orderId,
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res

      if (code === 1) {
        Object.keys(data).forEach((key) => {
          this.returnCarOrderData[key] = data[key]
        })
      }
    },
  },
  created() {
    this.init()
  },
  components: {
    ReturnCarStep,
    ReturnCarBeginDetail,
    CheckoutCarDetail,
    CheckoutOrderDetail,
    CheckoutExpenseDetail,
  },
}
</script>

<style lang="scss" scoped>
  .title {
    width: 100%;
    height: 40px;
    line-height: 40px;
    padding: 0 12px;
    font-weight: 600;
    font-size: 16px;
    color: #323233;
    margin-bottom: 14px;
  }
  .steps-wrapper {
    margin: 0 24px;
    padding: 24px 0 24px;
  }
</style>
